import React,{Component} from 'react'
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import MDBox from './MDBox';
import DashboardLayout from "./examples/LayoutContainers/DashboardLayout/index";
import DashboardNavbar from "./examples/Navbars/DashboardNavbar";
import { getToken } from './../util';
export default class Reports extends Component{
  constructor(){
    super()
    this.state={
      columns : [
        { field: 'firstname', headerName: 'NAME', width: 180, editable: false ,},
        { field: 'emailid', headerName: 'MAILID',  width: 280,editable: false  },
        { field: 'mobilenumber', headerName: 'MOBILENO', width: 280, editable: false ,},
        { field: 'companyname', headerName: 'COMPANY NAME', width: 380, editable: false ,},
        { field: 'designation', headerName: 'DESIGNATION', width: 280, editable: false ,},
      ],
      rows :[]
    }
  }
  componentDidMount=()=>{
    this.getLicenseDetails()
  }
  getLicenseDetails=()=>{
    this.setState({rows:[]})
    fetch(`eadmin/v1/set/get_user_not_generate_license`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        "x-access-token":getToken(),
      },
      }).then((response) => response.json())
      .then((responseJson) => {
      if(responseJson.status && responseJson.result.length>0){
        let id=1,data=[]
        for(var i=0;i<responseJson.result.length;i++){
          let tempdata={...responseJson.result[i],id:id,}
          id++
          data.push(tempdata)
        }
        //alert(JSON.stringify(data.length))
        this.setState({rows:data})
      }else if(!responseJson.status){
        alert(responseJson.errorMsg)
      }
    }).catch((error) => {
      alert(error)
    });
  }
  render(){
    return(
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="space-between" alignItems="center" >
          <Paper sx={{width:'100%'}}>
            <div style={{ height: 800, width:'100%' }}>
            <DataGrid
              sx={{
                boxShadow: 2,
                border: 2,
                borderColor: '#4A148C',
                fontWeight:'600',
                '& .MuiDataGrid-cell:hover': {
                  color: '900',
                },
              }}
              rows={this.state.rows}
              columns={this.state.columns}
            />
            </div>
          </Paper>
        </MDBox>
      </DashboardLayout>
    )
  }
}